import * as React from 'react';
import { ModalWindow, UIHeading2, UIText1, UIText2 } from '@cian/ui-kit';
import { IconActionClose16, IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';

import { IDistrictTaRating, TTaTab } from '../../../../types/infrastructure';
import { formatTaRate } from '../TaPanel';
import * as styles from './styles.css';

export interface ITaRatingModalProps {
  rating: IDistrictTaRating;
  tab: TTaTab;
  onClose(): void;
}

/** Детали оценки Дептранса: бары по характеристикам транспорта или чек-лист инфраструктуры внутри ЖК. */
export function TaRatingModal({ rating, tab, onClose }: ITaRatingModalProps): React.JSX.Element | null {
  const tabRating = tab === 'inside' ? rating.infrastructure : rating.transport;

  if (!tabRating) {
    return null;
  }

  return (
    <ModalWindow escape open portal title="Оценка от Дептранса" onClose={onClose}>
      <div className={styles['container']} data-testid="district-infrastructure-map-ta-rating-modal">
        <UIHeading2>{`${formatTaRate(tabRating.rate)} из 10`}</UIHeading2>
        <ul className={styles['details']}>
          {tab === 'inside'
            ? rating.infrastructure?.rateDetails.map((detail, index) => (
                <li className={styles['detail-check']} key={index}>
                  {detail.done ? (
                    <IconFunctionalSuccess16 color="icon-positive-default" />
                  ) : (
                    <IconActionClose16 color="icon-negative-default" />
                  )}
                  <UIText1>{detail.title}</UIText1>
                </li>
              ))
            : rating.transport?.rateDetails.map((detail, index) => (
                <li className={styles['detail']} key={index}>
                  <div className={styles['detail-row']}>
                    <UIText1>{detail.title}</UIText1>
                    <UIText2 color="text-secondary-default">{formatTaRate(detail.rate)}</UIText2>
                  </div>
                  <div className={styles['detail-bar']}>
                    <div
                      className={styles['detail-bar-value']}
                      style={{ width: `${Math.min(detail.rate, 10) * 10}%` }}
                    />
                  </div>
                </li>
              ))}
        </ul>
      </div>
    </ModalWindow>
  );
}
